export enum ROUTES {
    ABOUT = '/about',
    ACCEPT_JURY_INVITE = '/jury/invite/:token',
    ACCOUNT = '/account',
    ACCOUNT_BILLING = '/account/billing',
    ACCOUNT_COMMUNICATIONS = '/account/communication',
    ACCOUNT_HELP = '/account/help',
    ACCOUNT_NOTIFICATIONS = '/account/notification',
    ACCOUNT_PREFERENCE = '/account/preference',
    ACCOUNT_PREFERENCES = '/account/preferences',
    ACCOUNT_SETTINGS = '/account/settings',
    ACCOUNT_SUBSCRIPTION = '/account/subscription',
    ACCOUNT_EXTERNAL_ACCOUNT = '/account/external',
    API_LOADER = '/api',
    AUDITION = '/audme',
    MANAGE_AUDITION = '/audme/:id/manage',
    AUDITION_DETAIL = '/audme/:auditionId?',
    COMING_SOON = '/comingsoon',
    COMPANY = '/company/:id',
    COOKIE_PREFERENCE = '/cookie-preference',
    DASHBOARD = '/dashboard',
    DASHBOARD_EVENTS = '/dashboard/events',
    DASHBOARD_HELP = '/dashboard/help',
    DASHBOARD_JURYDUTY = '/dashboard/jury',
    DASHBOARD_MAIN = '/dashboard/main',
    DASHBOARD_PROFILE = '/dashboard/profile',
    DASHBOARD_PROJECT = '/dashboard/project',
    DASHBOARD_SETTINGS = '/dashboard/settings',
    DASHBOARD_SUBMISSIONS = '/dashboard/submissions',
    DASHBOARD_TEAMS = '/dashboard/teams',
    DISCOVER = '/discover',
    ESALL_CONTESTS = '/esall-contests',
    ESCOMING_SOON = '/coming-soon',
    ESCONTEST = '/submissions',
    ESCONTEST_ENGAGE = '/campaign-metrics/:contestId?',
    ESDISCOVERY = '/campaigns',
    ESJOIN_CONTESTS = '/esjoin-contest',
    ESJURY_DUTY = '/jury-duty',
    ESLIVE_CONTESTS = '/eslive-contests',
    ESLOGIN = '/login',
    ESMY_PROFILE = '/:profileId?',
    ESMY_VIDEOS = '/projects',
    ESNEWPASSWORD = '/new-password/:token?',
    ESRESETPASSWORD = '/reset-password',
    ESSETTINGS = '/settings',
    ESSIGNUP = '/signup',
    ESTRENDING = '/trending',
    ESVIEW_CONTEST = '/campaign/:contestId?',
    ESWATCH_VIDEO = '/watch',
    EVENT = '/event/:contestId?',
    EVENT_DETAILS = '/event/:eventId?',
    EVENT_CUSTOM = '/:hostName/:contestId?',
    EXCEPTION = '*',
    MENU_DASHBOARD = '/menu-dashboard',
    WATCH = '/watch-share',
    TERMS_OF_USE = '/terms-of-use',
    FAQ = '/faq',
    FEED = '/feed',
    FORGOT_PASSWORD = '/forgotPassword',
    GIG = '/gig',
    GIG_DETAIL = '/gig/:gigId',
    HELP_CENTER = '/help-center',
    HOME = '/',
    LANDING = '/landing',
    LINKS = '/links',
    LOGIN_IN = '/login',
    PHONE_AUTHENTICATION = '/verify',
    PRIVACY_POLICY = '/privacy-policy',
    PROFILE = '/profile',
    REGISTER = '/register',
    SEARCH = '/search',
    SETTINGS = '/settings',
    SHOP = '/shop',
    SPLASH = '/splash',
    SUBMIT = '/submit',
    TALENTS = '/talents',
    USER = '/:profileId?',
    VERIFY_EMAIL = '/email-verify/:token',
    WINNERS = '/winners',
    EVENTS = '/events',
    CONTEST_SUBMISSIONS = '/campaign/:contestId/entries',
    MESSAGES = '/messages',
    MESSAGES_CONVERSATION = '/messages/:roomId',
    MANAGE_EVENT = '/event/:id/manage',
    MANAGE_CONTEST = '/campaign/:contestId/manage',
    SOCIAL_AUTH_PAGE = '/auth/:provider/callback',
    BUZZ_BRIDGE = '/buzzbridge/dashboard',
    BUZZ_BRIDGE_LANDING = '/buzzbridge',
    BUZZ_BRIDGE_DETAILS = '/buzzbridge/:campaignId',
    WORK_PROFILE = '/p/:userName',
    WORK_SHOP = '/workshop/:projectId?',
    PROJECT_DETAILS = '/project-details/:slug',
}

export enum ROUTE_NAMES {
    ABOUT = 'about',
    WINNERS = 'winners',
    ACCOUNT = 'account',
    COMING_SOON = 'comingsoon',
    HOME = '',
    SUBMIT = 'submit',
    EXCEPTION = '*',
    API_LOADER = 'api',
    LOGIN_IN = 'login',
    REGISTER = 'register',
    PHONE_AUTHENTICATION = 'verify',
    DASHBOARD = 'dashboard',
    FORGOT_PASSWORD = 'forgotPassword',
    SETTINGS = 'settings',
    PROFILE = 'profile',
    SEARCH = 'search',
    LINKS = 'links',
    FEED = 'feed',
    GIG = 'gig',
    AUDITION = 'audme',
    EVENTS = 'events',
    BUZZ_BRIDGE = 'buzzbridge',
    WORK_SHOP = 'workshop',
}

export const APP_ROUTES = {
    ABOUT: '/about',
    WINNERS: '/winners',
    ACCOUNT: '/account',
    COMING_SOON: '/comingsoon',
    DISCOVER: '/discover',
    HOME: '/',
    USER: '/:profileId?',
    SUBMIT: '/submit',
    EXCEPTION: '*',
    API_LOADER: '/api',
    LOGIN_IN: '/login',
    REGISTER: '/register',
    PHONE_AUTHENTICATION: '/verify',
    DASHBOARD: '/dashboard',
    FORGOT_PASSWORD: '/forgotPassword',
    SETTINGS: '/settings',
    PROFILE: '/profile',
    SPLASH: '/splash',
    LANDING: '/landing',
    DASHBOARD_EVENTS: '/dashboard/events',
    DASHBOARD_JURYDUTY: '/dashboard/jury',
    DASHBOARD_PROFILE: '/dashboard/profile',
    DASHBOARD_PROJECT: '/dashboard/project',
    DASHBOARD_SETTINGS: '/dashboard/settings',
    DASHBOARD_SUBMISSIONS: '/dashboard/submissions',
    DASHBOARD_TEAMS: '/dashboard/teams',
    DASHBOARD_HELP: '/dashboard/help',
    DASHBOARD_MAIN: '/dashboard/main',
    ESLOGIN: '/login',
    ESSIGNUP: '/signup',
    ESRESETPASSWORD: '/reset-password',
    ESNEWPASSWORD: '/new-password/:token?',
    ESDISCOVERY: '/campaigns',
    ESVIEW_CONTEST: '/campaign/:contestId?',
    ESTRENDING: '/trending',
    ESCONTEST: '/submissions',
    ESMY_VIDEOS: '/projects',
    ESCOMING_SOON: '/coming-soon',
    ESMY_PROFILE: '/:profileId?',
    ESJURY_DUTY: '/jury-duty',
    ESWATCH_VIDEO: '/watch',
    ESALL_CONTESTS: '/esall-contests',
    ESJOIN_CONTESTS: '/esjoin-contest',
    ESLIVE_CONTESTS: '/eslive-contests',
    ESCONTEST_ENGAGE: '/campaign-metrics/:contestId',
    ESSETTINGS: '/settings',
    TERMS_OF_USE: '/terms-of-use',
    FAQ: '/faq',
    HELP_CENTER: '/help-center',
    SHOP: '/shop',
    PRIVACY_POLICY: '/privacy-policy',
    COOKIE_PREFERENCE: '/cookie-preference',
    SEARCH: '/search',
    VERIFY_EMAIL: '/email-verify',
    LINKS: '/links',
    TALENTS: '/talents',
    FEED: '/feed',
    GIG: '/gig',
    AUDITION: '/audme',
    EVENTS: '/events',
    SUBMISSIONS: '/submissions',
    PROJECTS: '/projects',
    CONTEST_SUBMISSIONS: '/campaign/:contestId/entries',
    MESSAGES: '/messages',
    MESSAGES_CONVERSATION: '/messages/:roomId',
    MANAGE_EVENT: '/event/:id/manage',
    MANAGE_CONTEST: '/campaign/:contestId/manage',
    BUZZ_BRIDGE: '/buzzbridge/dashboard',
    BUZZ_BRIDGE_LANDING: '/buzzbridge',
    BUZZ_BRIDGE_DETAILS: '/buzzbridge/:campaignId',
    WORK_SHOP: '/workshop',
};
